import React, { useState } from 'react'
import { ChildrenProps } from '../models/componentModel'
import { CommonResponseModel, createDataConnectorAssignementPayload, DataConnectorAssignment, dataConnectorAssignmentType, dataConnectorList, responseDataModel } from '../models/axiosModel';
import agent from '../services/api';
import { isSystemApi } from '../utils/constants';

const DataConnectorContext = React.createContext<DataConnectorContextpayload | undefined>(
  undefined
);

export interface DataConnectorContextpayload {
    dataConnectorList: dataConnectorList[] | null, 
    setDataConnectorList: React.Dispatch<React.SetStateAction<dataConnectorList[] | null>>,
    filteredDataConnectorList: dataConnectorList[] | null, 
    setFilteredDataConnectorList: React.Dispatch<React.SetStateAction<dataConnectorList[] | null>>,
    smartAssistToolList: dataConnectorList[] | null,
    setSmartAssistToolList: React.Dispatch<React.SetStateAction<dataConnectorList[] | null>>,
    dataConnectorAssignmentType: dataConnectorAssignmentType[], 
    setDataConnectorAssignmentType: React.Dispatch<React.SetStateAction<dataConnectorAssignmentType[]>>,

    getChatbotDataConnectorList: (flagSmartAssist?: boolean) => Promise<CommonResponseModel<dataConnectorList>>,
    getDataConnectorAssignmentType: () => Promise<CommonResponseModel<dataConnectorAssignmentType>>,
    assignDataConnectorAssignment: (payload: createDataConnectorAssignementPayload) => Promise<CommonResponseModel<responseDataModel>>,
    removeDataConnectorAssignment: (data_connector_assignement_id: number) => Promise<CommonResponseModel<responseDataModel>>,
    deleteDataConnector: (chatbot_data_connector_id: string) =>  Promise<CommonResponseModel<responseDataModel>>,
}


const DataConnectorProvider = ({ children }: ChildrenProps) => { 

    const [dataConnectorList, setDataConnectorList] = useState<dataConnectorList[] | null>(null);
    const [filteredDataConnectorList, setFilteredDataConnectorList] = useState<dataConnectorList[] | null>(null);
    const [smartAssistToolList, setSmartAssistToolList] = useState<dataConnectorList[] | null>(null);
    const [dataConnectorAssignmentType, setDataConnectorAssignmentType] = useState<dataConnectorAssignmentType[]>([]);


    const getChatbotDataConnectorList = async (flagSmartAssist?: boolean) => {
        const response = await agent.getChatbotDataConnectorList.get();

        // setDataConnectorList(dataConnectorListResObj);

        if (response.status) {
            const responseData = response.data; 
            if(flagSmartAssist){
                const data = responseData?.filter((data: dataConnectorList) => !isSystemApi(data?.chatbot_data_connector_function_path));
                setSmartAssistToolList(data);
                setFilteredDataConnectorList(data);
            } else {
                setDataConnectorList(responseData);
            }
        } else {
            setSmartAssistToolList(null);
            setDataConnectorList(null);
            setFilteredDataConnectorList(null);
        } 
        return response;
    } 

    const getDataConnectorAssignmentType = async () => {
        const res = await agent.getDataConnectorAssignmentType.get();

        // setDataConnectorAssignmentType(genericDataConnectorAssignementTypeResponse);
        if(res.status){
            setDataConnectorAssignmentType(res.data); 
        } else{
            setDataConnectorAssignmentType([]);
        } 
        return res;
    }

    const removeDataConnectorAssignment = async (data_connector_assignement_id: number) => {
        const res = await agent.deleteDataConnectorAssignment.delete(data_connector_assignement_id);
        return res;
    } 

    const assignDataConnectorAssignment = async (payload: createDataConnectorAssignementPayload) => {
        const res = await agent.createDataConnectorAssignment.post(payload);
        return res;
    } 

    const deleteDataConnector = async (chatbot_data_connector_id: string) => {
        const res = await agent.deleteDataConnector.delete(chatbot_data_connector_id);
        return res;
    }

    const payload = {
        dataConnectorList, 
        setDataConnectorList, 
        filteredDataConnectorList, 
        setFilteredDataConnectorList,
        smartAssistToolList, 
        setSmartAssistToolList,
        dataConnectorAssignmentType, 
        setDataConnectorAssignmentType,

        getChatbotDataConnectorList,
        getDataConnectorAssignmentType,
        assignDataConnectorAssignment,
        removeDataConnectorAssignment,
        deleteDataConnector,
    }
    return (
        <DataConnectorContext.Provider value={payload}> {children} </DataConnectorContext.Provider>
    )
}

export { DataConnectorContext, DataConnectorProvider}
